export const CONTACT = {
  email: "cxo@aeris.org.in",
  phone: "+91 9341010348",
  phoneHref: "tel:+919341010348",
  whatsapp: "https://wa.me/919341010348",
  website: "www.aeris.org.in",
};

export const NAV = [
  { label: "Home", path: "/" },
  { label: "Solutions", path: "/solutions" },
  { label: "Services", path: "/services" },
  { label: "Training", path: "/training" },
  { label: "Insights", path: "/insights" },
];

export const IMAGES = {
  heroHangar:
    "https://images.unsplash.com/photo-1617400210795-53720bf465c3?crop=entropy&cs=srgb&fm=jpg&q=85",
  darkCloseup:
    "https://images.unsplash.com/photo-1640262653848-adea46405e9f?crop=entropy&cs=srgb&fm=jpg&q=85",
  agriSpray:
    "https://images.unsplash.com/photo-1713952160156-bb59cac789a9?crop=entropy&cs=srgb&fm=jpg&q=85",
  agriField:
    "https://images.unsplash.com/photo-1656407410275-e63e689bcd90?crop=entropy&cs=srgb&fm=jpg&q=85",
  duskDrone:
    "https://images.unsplash.com/photo-1662113973702-e693151b8870?crop=entropy&cs=srgb&fm=jpg&q=85",
  cityNight:
    "https://images.unsplash.com/photo-1603793510575-a8cf24361baa?crop=entropy&cs=srgb&fm=jpg&q=85",
  cityAerial:
    "https://images.unsplash.com/photo-1536286144513-881bfbd3f292?crop=entropy&cs=srgb&fm=jpg&q=85",
  mineAerial:
    "https://images.unsplash.com/photo-1570979872224-a1ea9f1248b0?crop=entropy&cs=srgb&fm=jpg&q=85",
  controller:
    "https://images.unsplash.com/photo-1523346679608-dbbfe6c549d4?crop=entropy&cs=srgb&fm=jpg&q=85",
  pilotField:
    "https://images.unsplash.com/photo-1482169704817-5b66aafa1a01?crop=entropy&cs=srgb&fm=jpg&q=85",
  pilotHand:
    "https://images.unsplash.com/photo-1469313785555-277fa0c1dc9e?crop=entropy&cs=srgb&fm=jpg&q=85",
  disaster: "/disaster_response_drone.jpg",
};

export const STATS = [
  {
    value: 38575,
    suffix: "+",
    label: "Drones registered with UIN on Digital Sky",
    source: "PIB / Ministry of Civil Aviation, Feb 2026",
    testid: "stats-band-dgca-count",
  },
  {
    value: 39890,
    suffix: "+",
    label: "DGCA-certified remote pilots",
    source: "PIB / Ministry of Civil Aviation, Feb 2026",
    testid: "stats-band-pilot-count",
  },
  {
    value: 251,
    suffix: "",
    label: "Authorised Remote Pilot Training Organisations",
    source: "PIB / Ministry of Civil Aviation, Feb 2026",
    testid: "stats-band-rpto-count",
  },
  {
    value: 90,
    suffix: "%",
    label: "Airspace up to 400 ft is Green Zone — no permit needed",
    source: "Drone Rules, Government of India",
    testid: "stats-band-greenzone",
  },
];

export const SECTORS = [
  {
    id: "agriculture",
    index: "01",
    name: "AGRICULTURE",
    service: "Precision spraying",
    img: IMAGES.agriSpray,
    bullets: [
      "Uniform, targeted spraying that cuts chemical waste",
      "Crop-health scouting and field mapping",
      "Season-long service packages, billed by acre",
    ],
    signal:
      "1,094+ drones already delivered to women SHGs under the Namo Drone Didi scheme",
    signalSource: "PIB, Government of India",
  },
  {
    id: "defence",
    index: "02",
    name: "DEFENCE",
    service: "Aerial surveillance",
    img: IMAGES.duskDrone,
    bullets: [
      "Persistent perimeter and border monitoring",
      "Night patrols with thermal payloads",
      "Evidence-grade aerial records for rapid response",
    ],
    signal:
      "90% of Indian airspace up to 400 ft is Green Zone — no prior permission required",
    signalSource: "Drone Rules, Government of India",
  },
  {
    id: "infrastructure",
    index: "03",
    name: "INFRASTRUCTURE",
    service: "Inspection and mapping",
    img: IMAGES.cityNight,
    bullets: [
      "Structural inspection of bridges, towers and pipelines",
      "Orthophotos, 3D models and progress tracking",
      "Survey-grade outputs for EPC and government teams",
    ],
    signal:
      "3.28 lakh villages surveyed under SVAMITVA using drone mapping",
    signalSource: "SVAMITVA scheme, Government of India",
  },
  {
    id: "mining",
    index: "04",
    name: "MINING",
    service: "Surveying and monitoring",
    img: IMAGES.mineAerial,
    bullets: [
      "Volumetric stockpile analysis without shutting operations",
      "Haul-road and lease-boundary monitoring",
      "Safety inspection of highwalls and benches",
    ],
  },
  {
    id: "disaster",
    index: "05",
    name: "DISASTER MANAGEMENT",
    service: "Rapid aerial assessment",
    img: IMAGES.disaster,
    bullets: [
      "First-look damage assessment within hours, not days",
      "Aerial eyes over flood and landslide zones",
      "Relief-planning imagery for district authorities",
    ],
  },
  {
    id: "enterprise",
    index: "06",
    name: "ENTERPRISE",
    service: "Logistics support and data analysis",
    img: IMAGES.cityAerial,
    bullets: [
      "Last-mile aerial logistics support",
      "Site intelligence and periodic reporting",
      "Custom data pipelines from flight to dashboard",
    ],
  },
];

export const PILLARS = [
  {
    index: "01",
    name: "MANUFACTURE",
    desc: "Purpose-built drones engineered for Indian terrain and industries.",
  },
  {
    index: "02",
    name: "DEPLOY",
    desc: "Drone-as-a-Service with pay-per-use access and zero hardware burden.",
  },
  {
    index: "03",
    name: "TRAIN",
    desc: "Certified remote pilots building India's drone workforce.",
  },
];

export const CHALLENGES = [
  "Manual spraying, inspection and surveying are slow, costly and risky",
  "High cost of ownership keeps drones out of reach for most",
  "A shortage of trained, certified pilots",
  "Reliance on imported platforms not built for Indian conditions",
  "Fragmented vendors for hardware, operations and data",
];

export const EDGE = [
  {
    title: "End-to-end integration under one roof",
    desc: "Hardware, operations, training and data — one accountable team.",
  },
  {
    title: "Pay-per-use access that democratises drone technology",
    desc: "Fleet capability without the capital burden of ownership.",
  },
  {
    title: "Designed and supported in India for faster service",
    desc: "Indigenous platforms, domestic support, quicker turnarounds.",
  },
  {
    title: "Insight-led delivery: actionable data, not just flights",
    desc: "Every mission ends in a decision-ready deliverable.",
  },
  {
    title: "Asset-light scale through owned assets and partner-led execution",
    desc: "A hub-and-network model built for national reach.",
  },
];

export const FLYWHEEL = [
  {
    name: "DRONE SALES",
    desc: "Manufactured drones and accessories",
  },
  {
    name: "DAAS",
    desc: "Pay-per-use income by acre, hour or project",
  },
  {
    name: "PILOT TRAINING",
    desc: "Certified course fees",
  },
  {
    name: "AFTER-SALES",
    desc: "Maintenance, spare parts and data reporting",
  },
];

export const LOOP = [
  { act: "WE MANUFACTURE TO DRIVE EFFICIENCY", out: "Lower service cost" },
  { act: "WE TRAIN TO BUILD CAPABILITY", out: "Skilled pilot network" },
  { act: "WE DELIVER TO CREATE VALUE", out: "Reliable outcomes" },
  { act: "WE GROW TO SCALE IMPACT", out: "More demand, more opportunities" },
];

export const ROADMAP = [
  { phase: "01", name: "LAUNCH", desc: "Build fleet, pilot customers" },
  { phase: "02", name: "PROVE", desc: "Repeat missions, certify talent" },
  { phase: "03", name: "EXPAND", desc: "Regional hubs, sector depth" },
  { phase: "04", name: "LEAD", desc: "National network, data products" },
];

export const DAAS_STEPS = [
  { step: "BOOK", title: "Scope the mission" },
  { step: "DEPLOY", title: "Pilot + drone" },
  { step: "EXECUTE", title: "Fly safely" },
  { step: "DELIVER", title: "Data + insight" },
];

export const TRAINING_STATS = [
  {
    value: 39890,
    suffix: "+",
    label: "Remote pilots certified nationwide",
    source: "PIB / MoCA, Feb 2026",
  },
  {
    value: 251,
    suffix: "",
    label: "Authorised RPTOs across India",
    source: "PIB / MoCA, Feb 2026",
  },
  {
    value: 25791,
    suffix: "+",
    label: "Candidates trained in drone roles under PMKVY 4.0",
    source: "PIB, Dec 2025",
  },
  {
    value: 145,
    suffix: "+",
    label: "Indigenous type-certified UAS models",
    source: "Industry data, 2025-26",
  },
];

export const MARKET_BARS = [
  { year: "2025", value: 1.31, label: "USD 1.31 B" },
  { year: "2026", value: 1.43, label: "USD 1.43 B" },
  { year: "2030", value: 3.23, label: "USD 3.23 B" },
];

export const SOURCES = [
  {
    name: "PIB / Ministry of Civil Aviation — India's drone ecosystem: 38,575 UAVs registered, 39,890 pilots certified (Feb 2026)",
    url: "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2228954&lang=1&reg=3",
  },
  {
    name: "The Times of India — India's drone ecosystem expands (Feb 2026)",
    url: "https://timesofindia.indiatimes.com/defence/news/indias-drone-ecosystem-expands-38575-uavs-registered-39890-pilots-certified-as-of-february-2026/articleshow/128503752.cms",
  },
  {
    name: "IMARC Group — India Drones Market Report",
    url: "https://www.imarcgroup.com/india-drones-market",
  },
  {
    name: "PIB — PMKVY 4.0 drone-skilling update (Dec 2025)",
    url: "https://www.pib.gov.in/PressReleasePage.aspx?PRID=2245059&lang=1&reg=3",
  },
  {
    name: "ICAO — Remote Pilot Training Ecosystem in India (DGCA60 paper)",
    url: "https://www.icao.int/sites/default/files/APAC/Meetings/2025/2025%20DGCA60/Agenda%20Item04-Air%20Navigation/60-IP-04-05%20REMOTE%20PILOT%20TRAINING%20ECOSYSTEM%20IN%20INDIA.pdf",
  },
];

export const INTERESTS = [
  "Drone Sales",
  "Drone-as-a-Service",
  "Pilot Training",
  "After-Sales",
  "Partnership",
];
